import { config, authHeader } from '../helpers'
import { handleHttpResponse } from '../helpers';

export const EnergyService = {
    getEnergies,
}

// retrieves the labels of the given page id
function getEnergies() {
    const query = `{
        energy
        {
            id
            energyName
            isInjectionPossible
            hasCumulativeIndexes
            inputUnit
            conversionToKWH
            isDefaultEnergy
        }
      }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
    };
    return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.energy);
      })
  }